export default __webpack_public_path__ + "static/media/grid_zip.ac748179.svg";